<template>
    <div>
        <v-card>
            <div>
                <v-container>
                    <v-form v-if="currentProject" ref="form" :lazy-validation="lazy">
                        <p class="headline">End Your Project:</p>
                        <v-text-field disabled="true" v-model="currentProject.project.name"
                                      label="Project"></v-text-field>
                        <template v-if="!model.now">
                            <choose-date v-model="date" label="Date"></choose-date>
                            <choose-time v-model="to_time" label="End Time"></choose-time>
                        </template>
                        <v-checkbox color="primary" v-model="model.now" label="Now">Now</v-checkbox>

                        <v-btn color="primary" @click="update">End</v-btn>

                        <router-link :to="{name: 'UserProjectScheduleCalendar'}" tag="button">
                            <v-btn color="white">View Full Schedule</v-btn>
                        </router-link>
                    </v-form>

                    <v-form v-else ref="form" :lazy-validation="lazy">
                        <p class="headline">New Project Schedule:</p>
                        <template v-if="!model.now">
                            <choose-date v-model="date" label="Date"></choose-date>
                            <choose-time v-model="from_time" label="Start Time"></choose-time>
                        </template>
                        <v-checkbox color="primary" v-model="model.now" label="Now"></v-checkbox>
                        <v-select
                                label="Project"
                                :items="items"
                                item-value="id"
                                item-text="name"
                                v-model="model.project_id"></v-select>
                        <v-btn color="primary" @click="submit">Start</v-btn>
                        <router-link :to="{name: 'UserProjectScheduleCalendar'}" tag="button">
                            <v-btn color="white">View Full Schedule</v-btn>
                        </router-link>
                    </v-form>
                </v-container>
            </div>
        </v-card>
        <!--        </v-dialog>-->
        <!--        <data-table-->
        <!--                :url="api.ACTIONS.USER_PROJECT_SCHEDULES"-->
        <!--                :enable-add="false"-->
        <!--                :enable-edit="false"-->
        <!--                :formatter="formatter"-->
        <!--                :actions-extra-main="actionsExtraMain"-->
        <!--                :titles="titles"-->
        <!--                :disable-search="true"-->
        <!--                :fields-hidden-main="['updated_at','created_at','user_id','project_id']"-->
        <!--                :fields-hidden-add="['id','updated_at','created_at','user_id','project_id']"-->
        <!--                :fields-disabled-edit="['id','updated_at','created_at']"-->
        <!--        />-->
    </div>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import ChooseTime from "@/components/wasilni/input/ChooseTime";

    export default {
        name: "UserProjectSchedule",
        components: {ChooseTime, ChooseDate, DataTable},
        data() {
            return {
                items: null,
                dialog: false,
                valid: true,
                lazy: false,
                loading: false,
                requiredRules: [(v) => !!v || "الحقل مطلوب"],
                model: {
                    'from': null,
                    'to': null,
                    'now': true,
                    'project_id': null
                },
                date: null,
                from_time: null,
                to_time: null,
                currentProject: null
            }
        },
        computed: {
            titles() {
                return {
                    id: '#',
                    from: 'From',
                    to: 'To',
                    project: 'Project'
                }
            },
            formatter() {
                return {
                    to: (value) => value == null ? "Now" : value,
                    project: (value) => value.name
                }
            },
        },
        mounted() {
            this.loading = true;
            this.axios.get(this.api.ACTIONS.PROJECT)
                .then(res => {
                    this.items = res.data.data.data
                })
                .catch(err => console.log(err))
                .finally(() => this.loading = false);
            this.getCurrentProject();
        },
        methods:
            {
                getCurrentProject() {
                    this.axios.get('last-project-schedule')
                        .then(res => {
                            this.currentProject = res.data.data
                        })
                        .catch(err => console.log(err))
                        .finally(() => this.loading = false);
                },
                submit() {
                    this.loading = true;
                    this.model.from = (!this.model.now) ? this.date + ' ' + this.from_time : null;
                    this.model.to = null;
                    this.axios
                        .post(
                            this.api.ACTIONS.USER_PROJECT_SCHEDULES,
                            this.model
                        )
                        .then((res) => {
                            window.getApp.$emit("SHOW_TOAST", "Schedule Started!", "green");
                            this.dialog = false;
                        })
                        .catch((err) => {
                            let message = '';
                            try {
                                message = err.response.data.message;
                            } catch (e) {
                                message = 'failed, Server error';
                            }
                            window.getApp.$emit('SHOW_TOAST', message, 'red');
                        })
                        .finally(() => (this.loading = false, this.getCurrentProject()));
                },
                update() {
                    this.loading = true;
                    this.model.to = this.date + ' ' + this.to_time;
                    this.axios.put(
                        this.api.ACTIONS.USER_PROJECT_SCHEDULES + '/' + this.currentProject.id,
                        this.model
                    ).then((res) => {
                        window.getApp.$emit("SHOW_TOAST", "Schedule Ended!", "green");
                        this.dialog = false;
                    }).catch((err) => {
                        let message = '';
                        try {
                            message = err.response.data.message;
                        } catch (e) {
                            message = 'failed, Server error';
                        }
                        window.getApp.$emit('SHOW_TOAST', message, 'red');
                    })
                        .finally(() => (this.loading = false, this.getCurrentProject()));
                }
            }
    }
</script>

<style scoped>

</style>
